/**
 * Web substitute for react-native-config (uses CRA REACT_APP_* env vars).
 */
const Config: Record<string, string | undefined> = new Proxy(
  {},
  {
    get(_target, prop: string) {
      if (typeof prop !== "string") {
        return undefined;
      }
      return process.env[prop];
    },
  }
);

export default Config;
